import { render, staticRenderFns } from "./AttachmentsBlockRest.vue?vue&type=template&id=1ea5ff1c"
import script from "./AttachmentsBlockRest.vue?vue&type=script&lang=js"
export * from "./AttachmentsBlockRest.vue?vue&type=script&lang=js"
import style0 from "../attachments-shared.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports